const CookieInfoIcon = ({ width = 16, height = 16, ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 15.99 15.99"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      transform="translate(0.2998 0.2998)"
      d="M7.69519 14.6908C11.5588 14.6908 14.6908 11.5588 14.6908 7.69519C14.6908 3.83161 11.5588 0.699562 7.69519 0.699562C3.83161 0.699562 0.699562 3.83161 0.699562 7.69519C0.699562 11.5588 3.83161 14.6908 7.69519 14.6908Z"
      stroke="currentColor"
      strokeWidth="1.39912"
    />
    <path
      transform="translate(7.295 6.2961)"
      d="M0.699562 0.699562V4.69706"
      stroke="currentColor"
      strokeWidth="1.39912"
      strokeLinecap="round"
    />
    <path
      transform="translate(7.0963 4.0966)"
      d="M0.9 1.8C1.39706 1.8 1.8 1.39706 1.8 0.9C1.8 0.402944 1.39706 0 0.9 0C0.402944 0 0 0.402944 0 0.9C0 1.39706 0.402944 1.8 0.9 1.8Z"
      fill="currentColor"
    />
  </svg>
);

export default CookieInfoIcon;
